var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"join-wrap"},[_c('div',{staticClass:"join-img"},[_c('div',{staticClass:"bacImg"}),_c('p',{staticClass:"h1"},[_vm._v(_vm._s(_vm.$t('menu.job'))+" "),_vm._m(0)])]),_c('Core'),_c('Mission'),_c('Join')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://www.hotjob.cn/wt/BCSC/web/index","target":"_blank"}},[_c('i',{staticClass:"iconfont iconjob_offers"})])
}]

export { render, staticRenderFns }